var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "footerBig" } }, [
    _c("div", { attrs: { id: "footerSma" } }, [
      _c("div", { staticClass: "footerLogo", on: { click: _vm.toIndex } }, [
        _c("p", { staticClass: "logoIcon" }),
        _vm._v(" "),
        _c("p", { staticClass: "logoMsg" })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hrefBox" },
        _vm._l(_vm.hrefList, function(el, index) {
          return _c(
            "a",
            {
              class: index == 3 || index == 4 || index == 5 ? "down" : "up",
              attrs: { href: el.url, target: "_blank" }
            },
            [_vm._v(_vm._s(el.name))]
          )
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "careUs" }, [
        _c("div", { staticClass: "careLeft" }, [
          _c("span", { staticClass: "sina", on: { click: _vm.toSina } }),
          _vm._v(" "),
          _c("span", { staticClass: "tencent", on: { click: _vm.toTencent } }),
          _vm._v(" "),
          _c("p", [_vm._v("在这里关注我们的动向")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "careRight" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hr" }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("p", { staticClass: "footerCopy" }, [
        _vm._v(
          "北京神州同道智能信息技术有限公司版权所有 Copyright ©2002-" +
            _vm._s(_vm.footerNowYear) +
            " forex.com.cn.All Right Reserved 京ICP备19056818号 "
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "footerCopy" }, [
      _c("span", [_vm._v("")]),
      _vm._v("")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46e2ab3b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46e2ab3b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer/footer.vue
// module id = 399
// module chunks = 0 1 2 3